// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/persona/persona.proto" (package "base.persona", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { PersonaService } from "./persona";
import type { GetPresignedPutObjectUrlResponse } from "./persona";
import type { GetPresignedPutObjectUrlRequest } from "./persona";
import type { GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse } from "./persona";
import type { GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest } from "./persona";
import type { GetAllInsoleCustomDataResponse } from "./persona";
import type { GetAllInsoleCustomDataRequest } from "./persona";
import type { GetAccountsInsoleCustomDataResponse } from "./persona";
import type { GetAccountsInsoleCustomDataRequest } from "./persona";
import type { UpdateInsoleCustomShippingResponse } from "./persona";
import type { UpdateInsoleCustomShippingRequest } from "./persona";
import type { CreateOrUpdateInsoleCustomDataResponse } from "./persona";
import type { CreateOrUpdateInsoleCustomDataRequest } from "./persona";
import type { GetInsoleCustomDataListResponse } from "./persona";
import type { GetInsoleCustomDataListRequest } from "./persona";
import type { GetAllPersonaResponse } from "./persona";
import type { GetAllPersonaRequest } from "./persona";
import type { CreateBodyByAccessTokenResponse } from "./persona";
import type { CreateBodyByAccessTokenRequest } from "./persona";
import type { CreateOrUpdateSocialByAccessTokenResponse } from "./persona";
import type { CreateOrUpdateSocialByAccessTokenRequest } from "./persona";
import type { CreateOrUpdateWorkByAccessTokenResponse } from "./persona";
import type { CreateOrUpdateWorkByAccessTokenRequest } from "./persona";
import type { CreateOrUpdateContactByAccessTokenResponse } from "./persona";
import type { CreateOrUpdateContactByAccessTokenRequest } from "./persona";
import type { CreateOrUpdateIntrinsicByAccessTokenResponse } from "./persona";
import type { CreateOrUpdateIntrinsicByAccessTokenRequest } from "./persona";
import type { GetIntrinsicResponse } from "./persona";
import type { GetIntrinsicRequest } from "./persona";
import type { GetWorkResponse } from "./persona";
import type { GetWorkRequest } from "./persona";
import type { GetContactResponse } from "./persona";
import type { GetContactRequest } from "./persona";
import type { GetSocialResponse } from "./persona";
import type { GetSocialRequest } from "./persona";
import type { GetBodyResponse } from "./persona";
import type { GetBodyRequest } from "./persona";
import type { CreateOrUpdateSocialResponse } from "./persona";
import type { CreateOrUpdateSocialRequest } from "./persona";
import type { CreateOrUpdateWorkResponse } from "./persona";
import type { CreateOrUpdateWorkRequest } from "./persona";
import type { CreateOrUpdateContactResponse } from "./persona";
import type { CreateOrUpdateContactRequest } from "./persona";
import type { CreateOrUpdateIntrinsicResponse } from "./persona";
import type { CreateOrUpdateIntrinsicRequest } from "./persona";
import type { GetIntrinsicByAccountIdsResponse } from "./persona";
import type { GetIntrinsicByAccountIdsRequest } from "./persona";
import type { UpdateIntrinsicResponse } from "./persona";
import type { UpdateIntrinsicRequest } from "./persona";
import type { CreateIntrinsicResponse } from "./persona";
import type { CreateIntrinsicRequest } from "./persona";
import type { GetBodyByAccountIdsResponse } from "./persona";
import type { GetBodyByAccountIdsRequest } from "./persona";
import type { GetBodyListByAccountIdsResponse } from "./persona";
import type { GetBodyListByAccountIdsRequest } from "./persona";
import type { CreateBodyResponse } from "./persona";
import type { CreateBodyRequest } from "./persona";
import type { GetContactByAccountIdsResponse } from "./persona";
import type { GetContactByAccountIdsRequest } from "./persona";
import type { UpdateContactResponse } from "./persona";
import type { UpdateContactRequest } from "./persona";
import type { CreateContactResponse } from "./persona";
import type { CreateContactRequest } from "./persona";
import type { GetWorkByAccountIdsResponse } from "./persona";
import type { GetWorkByAccountIdsRequest } from "./persona";
import type { UpdateWorkResponse } from "./persona";
import type { UpdateWorkRequest } from "./persona";
import type { CreateWorkResponse } from "./persona";
import type { CreateWorkRequest } from "./persona";
import type { GetSocialByAccountIdsResponse } from "./persona";
import type { GetSocialByAccountIdsRequest } from "./persona";
import type { UpdateSocialResponse } from "./persona";
import type { UpdateSocialRequest } from "./persona";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateSocialResponse } from "./persona";
import type { CreateSocialRequest } from "./persona";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service base.persona.PersonaService
 */
export interface IPersonaServiceClient {
    /**
     * @generated from protobuf rpc: CreateSocial
     */
    createSocial(input: CreateSocialRequest, options?: RpcOptions): UnaryCall<CreateSocialRequest, CreateSocialResponse>;
    /**
     * @generated from protobuf rpc: UpdateSocial
     */
    updateSocial(input: UpdateSocialRequest, options?: RpcOptions): UnaryCall<UpdateSocialRequest, UpdateSocialResponse>;
    /**
     * @generated from protobuf rpc: GetSocialByAccountIds
     */
    getSocialByAccountIds(input: GetSocialByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetSocialByAccountIdsRequest, GetSocialByAccountIdsResponse>;
    /**
     * @generated from protobuf rpc: CreateWork
     */
    createWork(input: CreateWorkRequest, options?: RpcOptions): UnaryCall<CreateWorkRequest, CreateWorkResponse>;
    /**
     * @generated from protobuf rpc: UpdateWork
     */
    updateWork(input: UpdateWorkRequest, options?: RpcOptions): UnaryCall<UpdateWorkRequest, UpdateWorkResponse>;
    /**
     * @generated from protobuf rpc: GetWorkByAccountIds
     */
    getWorkByAccountIds(input: GetWorkByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetWorkByAccountIdsRequest, GetWorkByAccountIdsResponse>;
    /**
     * @generated from protobuf rpc: CreateContact
     */
    createContact(input: CreateContactRequest, options?: RpcOptions): UnaryCall<CreateContactRequest, CreateContactResponse>;
    /**
     * @generated from protobuf rpc: UpdateContact
     */
    updateContact(input: UpdateContactRequest, options?: RpcOptions): UnaryCall<UpdateContactRequest, UpdateContactResponse>;
    /**
     * @generated from protobuf rpc: GetContactByAccountIds
     */
    getContactByAccountIds(input: GetContactByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetContactByAccountIdsRequest, GetContactByAccountIdsResponse>;
    /**
     * @generated from protobuf rpc: CreateBody
     */
    createBody(input: CreateBodyRequest, options?: RpcOptions): UnaryCall<CreateBodyRequest, CreateBodyResponse>;
    /**
     * @generated from protobuf rpc: GetBodyListByAccountIds
     */
    getBodyListByAccountIds(input: GetBodyListByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetBodyListByAccountIdsRequest, GetBodyListByAccountIdsResponse>;
    /**
     * @generated from protobuf rpc: GetBodyByAccountIds
     */
    getBodyByAccountIds(input: GetBodyByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetBodyByAccountIdsRequest, GetBodyByAccountIdsResponse>;
    /**
     * @generated from protobuf rpc: CreateIntrinsic
     */
    createIntrinsic(input: CreateIntrinsicRequest, options?: RpcOptions): UnaryCall<CreateIntrinsicRequest, CreateIntrinsicResponse>;
    /**
     * @generated from protobuf rpc: UpdateIntrinsic
     */
    updateIntrinsic(input: UpdateIntrinsicRequest, options?: RpcOptions): UnaryCall<UpdateIntrinsicRequest, UpdateIntrinsicResponse>;
    /**
     * @generated from protobuf rpc: GetIntrinsicByAccountIds
     */
    getIntrinsicByAccountIds(input: GetIntrinsicByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetIntrinsicByAccountIdsRequest, GetIntrinsicByAccountIdsResponse>;
    /**
     * @generated from protobuf rpc: CreateOrUpdateIntrinsic
     */
    createOrUpdateIntrinsic(input: CreateOrUpdateIntrinsicRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateIntrinsicRequest, CreateOrUpdateIntrinsicResponse>;
    /**
     * @generated from protobuf rpc: CreateOrUpdateContact
     */
    createOrUpdateContact(input: CreateOrUpdateContactRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateContactRequest, CreateOrUpdateContactResponse>;
    /**
     * @generated from protobuf rpc: CreateOrUpdateWork
     */
    createOrUpdateWork(input: CreateOrUpdateWorkRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateWorkRequest, CreateOrUpdateWorkResponse>;
    /**
     * @generated from protobuf rpc: CreateOrUpdateSocial
     */
    createOrUpdateSocial(input: CreateOrUpdateSocialRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateSocialRequest, CreateOrUpdateSocialResponse>;
    /**
     * region 个人获取个人信息
     *
     * @generated from protobuf rpc: GetBody
     */
    getBody(input: GetBodyRequest, options?: RpcOptions): UnaryCall<GetBodyRequest, GetBodyResponse>;
    /**
     * @generated from protobuf rpc: GetSocial
     */
    getSocial(input: GetSocialRequest, options?: RpcOptions): UnaryCall<GetSocialRequest, GetSocialResponse>;
    /**
     * @generated from protobuf rpc: GetContact
     */
    getContact(input: GetContactRequest, options?: RpcOptions): UnaryCall<GetContactRequest, GetContactResponse>;
    /**
     * @generated from protobuf rpc: GetWork
     */
    getWork(input: GetWorkRequest, options?: RpcOptions): UnaryCall<GetWorkRequest, GetWorkResponse>;
    /**
     * @generated from protobuf rpc: GetIntrinsic
     */
    getIntrinsic(input: GetIntrinsicRequest, options?: RpcOptions): UnaryCall<GetIntrinsicRequest, GetIntrinsicResponse>;
    // region 个人创建或修改个人信息

    /**
     * @generated from protobuf rpc: CreateOrUpdateIntrinsicByAccessToken
     */
    createOrUpdateIntrinsicByAccessToken(input: CreateOrUpdateIntrinsicByAccessTokenRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateIntrinsicByAccessTokenRequest, CreateOrUpdateIntrinsicByAccessTokenResponse>;
    /**
     * @generated from protobuf rpc: CreateOrUpdateContactByAccessToken
     */
    createOrUpdateContactByAccessToken(input: CreateOrUpdateContactByAccessTokenRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateContactByAccessTokenRequest, CreateOrUpdateContactByAccessTokenResponse>;
    /**
     * @generated from protobuf rpc: CreateOrUpdateWorkByAccessToken
     */
    createOrUpdateWorkByAccessToken(input: CreateOrUpdateWorkByAccessTokenRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateWorkByAccessTokenRequest, CreateOrUpdateWorkByAccessTokenResponse>;
    /**
     * @generated from protobuf rpc: CreateOrUpdateSocialByAccessToken
     */
    createOrUpdateSocialByAccessToken(input: CreateOrUpdateSocialByAccessTokenRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateSocialByAccessTokenRequest, CreateOrUpdateSocialByAccessTokenResponse>;
    /**
     * @generated from protobuf rpc: CreateBodyByAccessToken
     */
    createBodyByAccessToken(input: CreateBodyByAccessTokenRequest, options?: RpcOptions): UnaryCall<CreateBodyByAccessTokenRequest, CreateBodyByAccessTokenResponse>;
    // endregion

    /**
     * @generated from protobuf rpc: GetAllPersona
     */
    getAllPersona(input: GetAllPersonaRequest, options?: RpcOptions): UnaryCall<GetAllPersonaRequest, GetAllPersonaResponse>;
    /**
     * sennofit pro
     *
     * @generated from protobuf rpc: GetInsoleCustomDataList
     */
    getInsoleCustomDataList(input: GetInsoleCustomDataListRequest, options?: RpcOptions): UnaryCall<GetInsoleCustomDataListRequest, GetInsoleCustomDataListResponse>;
    /**
     * @generated from protobuf rpc: CreateOrUpdateInsoleCustomData
     */
    createOrUpdateInsoleCustomData(input: CreateOrUpdateInsoleCustomDataRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateInsoleCustomDataRequest, CreateOrUpdateInsoleCustomDataResponse>;
    /**
     * @generated from protobuf rpc: UpdateInsoleCustomShipping
     */
    updateInsoleCustomShipping(input: UpdateInsoleCustomShippingRequest, options?: RpcOptions): UnaryCall<UpdateInsoleCustomShippingRequest, UpdateInsoleCustomShippingResponse>;
    /**
     * @generated from protobuf rpc: GetAccountsInsoleCustomData
     */
    getAccountsInsoleCustomData(input: GetAccountsInsoleCustomDataRequest, options?: RpcOptions): UnaryCall<GetAccountsInsoleCustomDataRequest, GetAccountsInsoleCustomDataResponse>;
    /**
     * @generated from protobuf rpc: GetAllInsoleCustomData
     */
    getAllInsoleCustomData(input: GetAllInsoleCustomDataRequest, options?: RpcOptions): UnaryCall<GetAllInsoleCustomDataRequest, GetAllInsoleCustomDataResponse>;
    /**
     * @generated from protobuf rpc: GetSocialAccountIdByRealNameContainsOrDisplayNameContains
     */
    getSocialAccountIdByRealNameContainsOrDisplayNameContains(input: GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest, options?: RpcOptions): UnaryCall<GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest, GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse>;
    /**
     * @generated from protobuf rpc: GetPresignedPutObjectUrl
     */
    getPresignedPutObjectUrl(input: GetPresignedPutObjectUrlRequest, options?: RpcOptions): UnaryCall<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse>;
}
/**
 * @generated from protobuf service base.persona.PersonaService
 */
export class PersonaServiceClient implements IPersonaServiceClient, ServiceInfo {
    typeName = PersonaService.typeName;
    methods = PersonaService.methods;
    options = PersonaService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: CreateSocial
     */
    createSocial(input: CreateSocialRequest, options?: RpcOptions): UnaryCall<CreateSocialRequest, CreateSocialResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateSocialRequest, CreateSocialResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateSocial
     */
    updateSocial(input: UpdateSocialRequest, options?: RpcOptions): UnaryCall<UpdateSocialRequest, UpdateSocialResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateSocialRequest, UpdateSocialResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSocialByAccountIds
     */
    getSocialByAccountIds(input: GetSocialByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetSocialByAccountIdsRequest, GetSocialByAccountIdsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSocialByAccountIdsRequest, GetSocialByAccountIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateWork
     */
    createWork(input: CreateWorkRequest, options?: RpcOptions): UnaryCall<CreateWorkRequest, CreateWorkResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateWorkRequest, CreateWorkResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateWork
     */
    updateWork(input: UpdateWorkRequest, options?: RpcOptions): UnaryCall<UpdateWorkRequest, UpdateWorkResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateWorkRequest, UpdateWorkResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetWorkByAccountIds
     */
    getWorkByAccountIds(input: GetWorkByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetWorkByAccountIdsRequest, GetWorkByAccountIdsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetWorkByAccountIdsRequest, GetWorkByAccountIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateContact
     */
    createContact(input: CreateContactRequest, options?: RpcOptions): UnaryCall<CreateContactRequest, CreateContactResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateContactRequest, CreateContactResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateContact
     */
    updateContact(input: UpdateContactRequest, options?: RpcOptions): UnaryCall<UpdateContactRequest, UpdateContactResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateContactRequest, UpdateContactResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetContactByAccountIds
     */
    getContactByAccountIds(input: GetContactByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetContactByAccountIdsRequest, GetContactByAccountIdsResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetContactByAccountIdsRequest, GetContactByAccountIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateBody
     */
    createBody(input: CreateBodyRequest, options?: RpcOptions): UnaryCall<CreateBodyRequest, CreateBodyResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateBodyRequest, CreateBodyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBodyListByAccountIds
     */
    getBodyListByAccountIds(input: GetBodyListByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetBodyListByAccountIdsRequest, GetBodyListByAccountIdsResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetBodyListByAccountIdsRequest, GetBodyListByAccountIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetBodyByAccountIds
     */
    getBodyByAccountIds(input: GetBodyByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetBodyByAccountIdsRequest, GetBodyByAccountIdsResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetBodyByAccountIdsRequest, GetBodyByAccountIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateIntrinsic
     */
    createIntrinsic(input: CreateIntrinsicRequest, options?: RpcOptions): UnaryCall<CreateIntrinsicRequest, CreateIntrinsicResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateIntrinsicRequest, CreateIntrinsicResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateIntrinsic
     */
    updateIntrinsic(input: UpdateIntrinsicRequest, options?: RpcOptions): UnaryCall<UpdateIntrinsicRequest, UpdateIntrinsicResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateIntrinsicRequest, UpdateIntrinsicResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetIntrinsicByAccountIds
     */
    getIntrinsicByAccountIds(input: GetIntrinsicByAccountIdsRequest, options?: RpcOptions): UnaryCall<GetIntrinsicByAccountIdsRequest, GetIntrinsicByAccountIdsResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetIntrinsicByAccountIdsRequest, GetIntrinsicByAccountIdsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateOrUpdateIntrinsic
     */
    createOrUpdateIntrinsic(input: CreateOrUpdateIntrinsicRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateIntrinsicRequest, CreateOrUpdateIntrinsicResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrUpdateIntrinsicRequest, CreateOrUpdateIntrinsicResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateOrUpdateContact
     */
    createOrUpdateContact(input: CreateOrUpdateContactRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateContactRequest, CreateOrUpdateContactResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrUpdateContactRequest, CreateOrUpdateContactResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateOrUpdateWork
     */
    createOrUpdateWork(input: CreateOrUpdateWorkRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateWorkRequest, CreateOrUpdateWorkResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrUpdateWorkRequest, CreateOrUpdateWorkResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateOrUpdateSocial
     */
    createOrUpdateSocial(input: CreateOrUpdateSocialRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateSocialRequest, CreateOrUpdateSocialResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrUpdateSocialRequest, CreateOrUpdateSocialResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * region 个人获取个人信息
     *
     * @generated from protobuf rpc: GetBody
     */
    getBody(input: GetBodyRequest, options?: RpcOptions): UnaryCall<GetBodyRequest, GetBodyResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetBodyRequest, GetBodyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSocial
     */
    getSocial(input: GetSocialRequest, options?: RpcOptions): UnaryCall<GetSocialRequest, GetSocialResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSocialRequest, GetSocialResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetContact
     */
    getContact(input: GetContactRequest, options?: RpcOptions): UnaryCall<GetContactRequest, GetContactResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetContactRequest, GetContactResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetWork
     */
    getWork(input: GetWorkRequest, options?: RpcOptions): UnaryCall<GetWorkRequest, GetWorkResponse> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetWorkRequest, GetWorkResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetIntrinsic
     */
    getIntrinsic(input: GetIntrinsicRequest, options?: RpcOptions): UnaryCall<GetIntrinsicRequest, GetIntrinsicResponse> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetIntrinsicRequest, GetIntrinsicResponse>("unary", this._transport, method, opt, input);
    }
    // region 个人创建或修改个人信息

    /**
     * @generated from protobuf rpc: CreateOrUpdateIntrinsicByAccessToken
     */
    createOrUpdateIntrinsicByAccessToken(input: CreateOrUpdateIntrinsicByAccessTokenRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateIntrinsicByAccessTokenRequest, CreateOrUpdateIntrinsicByAccessTokenResponse> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrUpdateIntrinsicByAccessTokenRequest, CreateOrUpdateIntrinsicByAccessTokenResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateOrUpdateContactByAccessToken
     */
    createOrUpdateContactByAccessToken(input: CreateOrUpdateContactByAccessTokenRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateContactByAccessTokenRequest, CreateOrUpdateContactByAccessTokenResponse> {
        const method = this.methods[25], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrUpdateContactByAccessTokenRequest, CreateOrUpdateContactByAccessTokenResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateOrUpdateWorkByAccessToken
     */
    createOrUpdateWorkByAccessToken(input: CreateOrUpdateWorkByAccessTokenRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateWorkByAccessTokenRequest, CreateOrUpdateWorkByAccessTokenResponse> {
        const method = this.methods[26], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrUpdateWorkByAccessTokenRequest, CreateOrUpdateWorkByAccessTokenResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateOrUpdateSocialByAccessToken
     */
    createOrUpdateSocialByAccessToken(input: CreateOrUpdateSocialByAccessTokenRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateSocialByAccessTokenRequest, CreateOrUpdateSocialByAccessTokenResponse> {
        const method = this.methods[27], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrUpdateSocialByAccessTokenRequest, CreateOrUpdateSocialByAccessTokenResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateBodyByAccessToken
     */
    createBodyByAccessToken(input: CreateBodyByAccessTokenRequest, options?: RpcOptions): UnaryCall<CreateBodyByAccessTokenRequest, CreateBodyByAccessTokenResponse> {
        const method = this.methods[28], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateBodyByAccessTokenRequest, CreateBodyByAccessTokenResponse>("unary", this._transport, method, opt, input);
    }
    // endregion

    /**
     * @generated from protobuf rpc: GetAllPersona
     */
    getAllPersona(input: GetAllPersonaRequest, options?: RpcOptions): UnaryCall<GetAllPersonaRequest, GetAllPersonaResponse> {
        const method = this.methods[29], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllPersonaRequest, GetAllPersonaResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * sennofit pro
     *
     * @generated from protobuf rpc: GetInsoleCustomDataList
     */
    getInsoleCustomDataList(input: GetInsoleCustomDataListRequest, options?: RpcOptions): UnaryCall<GetInsoleCustomDataListRequest, GetInsoleCustomDataListResponse> {
        const method = this.methods[30], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetInsoleCustomDataListRequest, GetInsoleCustomDataListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateOrUpdateInsoleCustomData
     */
    createOrUpdateInsoleCustomData(input: CreateOrUpdateInsoleCustomDataRequest, options?: RpcOptions): UnaryCall<CreateOrUpdateInsoleCustomDataRequest, CreateOrUpdateInsoleCustomDataResponse> {
        const method = this.methods[31], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateOrUpdateInsoleCustomDataRequest, CreateOrUpdateInsoleCustomDataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateInsoleCustomShipping
     */
    updateInsoleCustomShipping(input: UpdateInsoleCustomShippingRequest, options?: RpcOptions): UnaryCall<UpdateInsoleCustomShippingRequest, UpdateInsoleCustomShippingResponse> {
        const method = this.methods[32], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateInsoleCustomShippingRequest, UpdateInsoleCustomShippingResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAccountsInsoleCustomData
     */
    getAccountsInsoleCustomData(input: GetAccountsInsoleCustomDataRequest, options?: RpcOptions): UnaryCall<GetAccountsInsoleCustomDataRequest, GetAccountsInsoleCustomDataResponse> {
        const method = this.methods[33], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccountsInsoleCustomDataRequest, GetAccountsInsoleCustomDataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAllInsoleCustomData
     */
    getAllInsoleCustomData(input: GetAllInsoleCustomDataRequest, options?: RpcOptions): UnaryCall<GetAllInsoleCustomDataRequest, GetAllInsoleCustomDataResponse> {
        const method = this.methods[34], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAllInsoleCustomDataRequest, GetAllInsoleCustomDataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSocialAccountIdByRealNameContainsOrDisplayNameContains
     */
    getSocialAccountIdByRealNameContainsOrDisplayNameContains(input: GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest, options?: RpcOptions): UnaryCall<GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest, GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse> {
        const method = this.methods[35], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSocialAccountIdByRealNameContainsOrDisplayNameContainsRequest, GetSocialAccountIdByRealNameContainsOrDisplayNameContainsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPresignedPutObjectUrl
     */
    getPresignedPutObjectUrl(input: GetPresignedPutObjectUrlRequest, options?: RpcOptions): UnaryCall<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse> {
        const method = this.methods[36], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPresignedPutObjectUrlRequest, GetPresignedPutObjectUrlResponse>("unary", this._transport, method, opt, input);
    }
}
